import React from 'react';

export const TitleContent = ({ text, className = '' }) => {
  return (
    <p className={`font-inter font-bold text-black2 mb-2 ${className}`}>
      {text}
    </p>
  );
};
